import { State } from './State';
import { RuleEntry } from './RuleEntry';

export class StateEntry {
  state: State;
  rules: RuleEntry[] = [];

  constructor(state: State) {
    this.state = state;
  }
}
